import { authenticatedInstance } from 'api';

export const GENERATE_KYC_KEYS = {
  STARTED: 'GENERATE_KYC_KEYS_STARTED',
  SUCCESS: 'GENERATE_KYC_KEYS_SUCCESS',
  FAIL: 'GENERATE_KYC_KEYS_FAIL',
};

export const generateKycKeys = () => {
  return async (dispatch) => {
    dispatch({ type: GENERATE_KYC_KEYS.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/api/GetArgumentumClientKey',
        method: 'GET',
      });

      dispatch({
        type: GENERATE_KYC_KEYS.SUCCESS,
        payload: data,
      });
    } catch (e) {
      dispatch({ type: GENERATE_KYC_KEYS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};
